import React, { useState, useEffect } from "react";
import { Input, DatePicker, Button } from "antd";
import moment from "moment";
import { createReviewPeriod, updateReviewPeriod } from "../../../service/appraisalService";
import propTypes from 'prop-types';

const CreateReviewPeriod = ({ selectedReviewPeriod, handleCancel, handleReload }) => {
  const [name, setName] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [status, setStatus] = useState("Active");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedReviewPeriod) {
      setName(selectedReviewPeriod.name);
      setStartDate(moment(selectedReviewPeriod.startDate));
      setEndDate(moment(selectedReviewPeriod.endDate));
      setStatus(selectedReviewPeriod.status);
    }
  }, [selectedReviewPeriod]);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const periodData = { name, startDate: startDate?.toISOString(), endDate: endDate?.toISOString(), status };
      if (selectedReviewPeriod) {
        await updateReviewPeriod(selectedReviewPeriod._id, periodData);
      } else {
        await createReviewPeriod(periodData);
      }
      handleReload();
      handleCancel();
    } catch (error) {
      console.error("Error saving review period:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h4>{selectedReviewPeriod ? "Edit Review Period" : "Create Review Period"}</h4>
      <div className="form-group">
        <label>Name</label>
        <Input value={name} onChange={(e) => setName(e.target.value)} />
      </div>
      <div className="form-group">
        <label>Start Date</label>
        <DatePicker
          value={startDate}
          onChange={(date) => setStartDate(date)}
          style={{ width: "100%" }}
          format="YYYY-MM-DD"
        />
      </div>
      <div className="form-group">
        <label>End Date</label>
        <DatePicker
          value={endDate}
          onChange={(date) => setEndDate(date)}
          style={{ width: "100%" }}
          format="YYYY-MM-DD"
        />
      </div>
      <div className="form-group">
        <label>Status</label>
        <Input value={status} onChange={(e) => setStatus(e.target.value)} />
      </div>
      <div className="form-group d-flex justify-content-end">
        <Button className="btn btn-cancel me-2" onClick={handleCancel}>
          Cancel
        </Button>
        <Button className="btn btn-submit" onClick={handleSubmit} loading={loading}>
          {selectedReviewPeriod ? "Update" : "Submit"}
        </Button>
      </div>
    </div>
  );
};

CreateReviewPeriod.propTypes = {
    selectedReviewPeriod: propTypes.func.isRequired,
        handleCancel: propTypes.func.isRequired,
            handleReload: propTypes.func.isRequired


};

export default CreateReviewPeriod;

